import lozad from "lozad";
import {
	setBackgroundElement,
	detectCloseElement,
	buttonToTop,
	clickScrollToDiv,
	countUpInit,
	ToggleItem,
	draggableScroll,
} from "./helper";
import { header } from "./header";
import { swiperInit } from "./swiper";
import { animation } from "./animation";
$(document).ready(function () {
	setBackgroundElement();
	header.init();
	swiperInit();
	animation.init();
	handleSelect2();
	buttonToTop();
	ToggleItem();
	// countUpInit();
	watchObserveInputFile();
	selectDropdown();
	loadMoreJobs();
	updateDescHeight();
	handleHoverImage();
	getHeightChild();
	initSlideBackgroundHover();
	toggleCheckbox();
	toggleFillterProduct();
	handleButtonSubmit();
	draggableScroll({
		parent: "section.contact ul.tabslet-tab",
	});
	const tops = document.querySelectorAll(".home-2 .wrapper-lists .item .top");
	let maxHeight = 0;

	tops.forEach((top) => {
		const height = top.offsetHeight;
		if (height > maxHeight) maxHeight = height;
	});

	tops.forEach((top) => {
		top.style.height = maxHeight + "px";
	});

	$(document).on("click", ".suggestions .item", function () {
		// Xóa active ở tất cả item
		$(".suggestions .item").removeClass("active");
		// Thêm active cho item được click
		$(this).addClass("active");
	});

	document.querySelectorAll(".home-7-list > div").forEach((col) => {
		if (!col.innerHTML.trim()) {
			col.innerHTML = '<p class="text-center text-gray-500 italic">Đang cập nhật</p>';
		}
	});

	$(document).on("submit", "#form-search", function (e) {
		$(this).addClass("submitting");

		// Giả sử sau 2s thì bỏ trạng thái submitting
		setTimeout(() => {
			$(this).removeClass("submitting");
		}, 2000);
	});

	// Hover vào mỗi item bên col-right
	$(".product-detail-5 .wrapper-list .item").hover(function () {
		const target = $(this).attr("id");

		// Gỡ active tất cả ảnh bên col-left
		$(".product-detail-5 .col-left .img").removeClass("active");

		// Thêm active cho ảnh có data-target tương ứng
		$(`.product-detail-5 .col-left .img[data-target="${target}"]`).addClass("active");
	});
	$(window).on("resize", function () {
		updateDescHeight();
	});
	// $(".home-3 .slide .item").hover(
	// 	function () {
	// 		// Hover vào
	// 		$(this).addClass("active");
	// 	},
	// 	function () {
	// 		// Rời chuột ra
	// 		$(this).removeClass("active");
	// 	}
	// );
	// menuSpyAbout();
});

function handleSelect2 () {
	$('.about-7-select .select-view-item select, .business .select-view-item select').each(function () {
		const placeholder = $(this).attr('placeholder');
		$(this).select2({
			placeholder: placeholder,
			allowClear: false,
			minimumResultsForSearch: Infinity,
			language: {
				noResults: function () {
					return "Không có kết quả";
				}
			}
		});
	});
	// Open dropdown on hover

	$('.box-table .select-view-item select').each(function () {
		const placeholder = $(this).attr('placeholder');
		const numberOptions = $(this).find('option').length;
		if (numberOptions <= 1) {
			$(this).closest('.select-view-item').addClass('hidden-select');
		}
		if (window.matchMedia('(min-width: 1024px)').matches) {
			$(this).select2({
				placeholder: placeholder,
				allowClear: false,
				minimumResultsForSearch: Infinity,
				closeOnSelect: false, // This keeps dropdown open after selection

				language: {
					noResults: function () {
						return "Không có kết quả";
					}
				}
			});
		}
	});
	if (window.matchMedia('(min-width: 1024px)').matches) {
		$('.box-table .select-view-item select').next('.select2').on('mouseenter', function () {
			console.log($(this));
			$('.box-table .select-view-item select').select2('close');
			$(this).closest('.box-table .select-view-item').find('select').select2('open');
		});
	}

	// $(document).on('mouseleave', '.table-items .select-view-item .select2-container', function (e) {
	// 	// Check if mouse is not moving to dropdown results
	// 	if ($(e.relatedTarget).closest('.select2-container').length === 0) {
	// 		$(this).closest('.table-items .select-view-item').find('select').select2('close');
	// 	}
	// });
}

function menuSpyAbout () {

	var elm = document.querySelector(".header-nav>li:first-child");
	console.log(elm);
	var ms = new MenuSpy(elm, {
		activeClass: "active",
		threshold: 300,
	});
}

function toggleFillterProduct () {
	// Bật / tắt class active khi click toggle
	$(".toggle-filter").on("click", function () {
		$('body').toggleClass('overlay-active');
		$(".col-left").toggleClass("active");
	});

	// Xoá class active khi click nút đóng
	$(".btn-close-filter-product-mobile i").on("click", function () {
		$('body').removeClass('overlay-active');
		$(".col-left").removeClass("active");
	});

	detectCloseElement('.toggle-filter', '.btn-close-filter-product-mobile i', function () {
		$('body').removeClass('overlay-active');
		$(".col-left").removeClass("active");
	});
}
function handleButtonSubmit () {
	const form = document.querySelector(".wpcf7 form");
	if (!form) return;
	const buttons = form.querySelectorAll(".wpcf7-submit");
	const hiddenInput = form.querySelector("#submit-type");

	// Khi click nút, set giá trị và thêm class loading cho nút đó
	buttons.forEach((btn, index) => {
		btn.addEventListener("click", function () {
			// Xoá loading tất cả trước
			buttons.forEach((b) => b.classList.remove("submitting"));

			if (index === 0) {
				hiddenInput.value = "cuoc-goi";
			} else {
				hiddenInput.value = "zalo";
			}

			btn.classList.add("submitting");
		});
	});

	// Khi gửi xong hoặc lỗi thì bỏ loading
	document.addEventListener("wpcf7submit", function () {
		buttons.forEach((btn) => btn.classList.remove("submitting"));
	});
	document.addEventListener("wpcf7invalid", function () {
		buttons.forEach((btn) => btn.classList.remove("submitting"));
	});
}
function getHeightChild () {
	$(".item-var-height").each(function () {
		const height = $(this).outerHeight();
		$(this)
			.closest(".wrap-item-height")
			.css("--height-ele", height + "px");
	});
}
function updateDescHeight () {
	$(".item-var-height").each(function () {
		const desc = $(this);
		const height = desc.outerHeight(true); // tính luôn margin nếu có
		desc.closest(".wrap-item-height").css("--desc-height", height + "px");
	});
}
function handleHoverImage () {
	// Set ảnh đầu tiên mặc định
	const firstImage = $(".about-3-circle .box").first().data("image");
	if (firstImage) {
		$(".content-image-main img").attr("src", firstImage).addClass("fade-in");
		$(".about-3-circle .box").first().addClass("active");
	}

	// Khi hover vào từng .box
	$(".about-3-circle .box").on("mouseenter", function () {
		const imageSrc = $(this).data("image");

		// Gỡ active khỏi các box khác
		$(".about-3-circle .box").removeClass("active");
		// Thêm active cho box hiện tại
		$(this).addClass("active");

		// Cập nhật ảnh
		if (imageSrc) {
			$(".content-image-main img").attr("src", imageSrc);
		}
	});
}
function toggleCheckbox () {
	document.querySelectorAll(".facetwp-checkbox").forEach((checkbox) => {
		// Đảm bảo checkbox không có class "checked" khi mới load
		checkbox.classList.remove("checked");

		// Thêm sự kiện click để toggle class "checked"
		checkbox.addEventListener("click", function () {
			this.classList.toggle("checked");
		});
	});
}
function selectDropdown () {
	// Ẩn dropdown ban đầu
	$(".custom-dropdown").on("click", function () {
		const $dropdown = $(this).closest(".custom-dropdown");
		$dropdown.find(".dropdown-options").toggleClass("active");
	});

	// Chọn option
	$(".custom-dropdown .dropdown-options li").on("click", function () {
		const selectedText = $(this).text();
		const selectedValue = $(this).data("value");

		const $dropdown = $(this).closest(".custom-dropdown");
		$dropdown.find(".dropdown-selected").text(selectedText);

		// Lưu value nếu cần
		$dropdown.attr("data-selected-value", selectedValue);

		// Ẩn lại
		$dropdown.find(".dropdown-options").removeClass("active");
	});

	// Click ngoài thì ẩn dropdown
	$(document).on("click", function (e) {
		if (!$(e.target).closest(".custom-dropdown").length) {
			$(".custom-dropdown .dropdown-options").removeClass("active");
		}
	});
}

function initSlideBackgroundHover (
	containerSelector = ".product-detail-6-slide",
	slideSelector = ".product-detail-6-slide .swiper-slide"
) {
	// Gán background ban đầu từ setBackground
	$(containerSelector + "[setBackground]").each(function () {
		var bg = $(this).attr("setBackground");
		$(this).css({
			"background-image": "url(" + bg + ")",
			"background-size": "cover",
			"background-position": "center center",
			// transition: "0.3s ease",
		});
	});

	// ✅ Slide đầu tiên thực sự (bỏ qua clone khi loop: true)
	const $firstRealSlide = $(slideSelector).not(".swiper-slide-duplicate").eq(0);
	const bgFirst = $firstRealSlide.attr("data-background");

	if (bgFirst) {
		// Gán background ảnh đầu
		$(containerSelector)
			.attr("setBackground", bgFirst)
			.css({
				"background-image": "url(" + bgFirst + ")",
				"background-size": "cover",
				"background-position": "center center",
				// transition: "0.3s ease",
			});
	}

	// ✅ Thêm class active cho .item-service-primary trong slide đầu
	$firstRealSlide.find(".item-service-primary").addClass("active");

	// Hover vào mỗi slide thì đổi background
	$(slideSelector).on("mouseenter", function () {
		if ($(this).hasClass("swiper-slide-duplicate")) return;

		var bg = $(this).attr("data-background");
		if (bg) {
			$(containerSelector)
				.attr("setBackground", bg)
				.css({
					"background-image": "url(" + bg + ")",
					"background-size": "cover",
					"background-position": "center center",
					// transition: "0.5s ease",
				});
		}

		// ✅ Bỏ .active ở các slide khác, gán lại cho slide đang hover
		$(slideSelector).find(".item-service-primary").removeClass("active");
		$(this).find(".item-service-primary").addClass("active");
	});
}

// function showMoreContent() {
// 	$(".product-detail-1 .btn-more").on("click", function (e) {
// 		e.preventDefault();
// 		$(".format-content").toggleClass("expanded");

// 		// Đổi icon/label nếu cần
// 		const isExpanded = $(".format-content").hasClass("expanded");
// 		$(this)
// 			.find("span")
// 			.text(isExpanded ? "Thu gọn" : "Xem thêm");
// 		$(this).find("i").toggleClass("fa-angle-down fa-angle-up");
// 	});
// }

function loadMoreJobs () {
	const btnMore = document.querySelector(".more");
	if (!btnMore) return;

	const hiddenRows = document.querySelectorAll("tr.hidden");
	let index = 0;
	const showCount = 4;

	function handleLoadMore (event) {
		event.preventDefault();

		for (let i = index; i < index + showCount && i < hiddenRows.length; i++) {
			hiddenRows[i].classList.remove("hidden");
		}
		index += showCount;

		btnMore.style.display = index < hiddenRows.length ? "flex" : "none";
	}

	btnMore.addEventListener("click", handleLoadMore);

	btnMore.style.display = hiddenRows.length > 0 ? "flex" : "none";
}

// export function indicatorSlide() {
// 	if ($(".indicator-swipe").length > 0) {
// 		var callback = function (entries) {
// 			entries.forEach(function (entry) {
// 				if (entry.isIntersecting) {
// 					entry.target.classList.add("active");
// 					setTimeout(function () {
// 						entry.target.classList.remove("active");
// 					}, 3000);
// 				}
// 			});
// 		};

// 		var observer = new IntersectionObserver(callback);
// 		var animationItems = document.querySelectorAll(".indicator-swipe");
// 		animationItems.forEach(function (item) {
// 			observer.observe(item);
// 		});
// 	}
// }

function watchObserveInputFile () {
	$('input[name="file-cv"]').on("change", function () {
		const file = this.files[0];
		if (file) {
			const fileName = file.name;
			const fileNameDisplay = $("<span>", {
				class: "file-name text-sm text-body-text-66 mt-1 block",
				text: "File CV: " + fileName,
			});

			$(this).closest(".form-input-file").find(".file-name").remove();

			$(this).closest(".form-input-file").append(fileNameDisplay);
		}
	});
}

/*==================== Aos Init ====================*/

/*==================== Lazyload JS ====================*/
const observer = lozad(); // lazy loads elements with default selector as '.lozad'
observer.observe();

window.observer = observer;
